import type { Product } from '../../../data/product';
import { defineColumn, type StrictColumnDef } from '../../tanstack-table/column';

export const Type: StrictColumnDef<Product> = defineColumn<Product>({
  id: 'Type',
  minWidth: 120,
  maxWidth: 256,
  accessorFn: (product) => product.type,
});
